import React from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useStyles from '../ContactCell.style';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Chip, IconButton, Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { deleteNews } from 'redux/actions/NewsManager';
import { toPersianDate } from '@jumbo/utils/dateHelper';
import useSwalWrapper from '@jumbo/vendors/sweetalet2/hook';
import CmtAvatar from '@coremat/CmtAvatar';

const NewsItemCell = ({ newsItem }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const Swal = useSwalWrapper();

  const { title, id, verified, traslated, newsDate, posters } = newsItem;

  const handleDelete = () => {
    Swal.fire({
      title: `آیا از حذف ${title} مطمعن هستید؟`,
      icon: 'warning',
      iconHtml: '؟',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'حذف',
      cancelButtonText: 'لغو',
      showCancelButton: true,
      showCloseButton: true,
      preConfirm: () => dispatch(deleteNews(id)),
    });
  };

  return (
    <TableRow className={classes.tableRowRoot}>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Box mr={{ xs: 4, md: 5 }}>
            <CmtAvatar size={40} src={posters.medium} />
          </Box>

          <Typography className={classes.titleRoot} component="div" variant="h4">
            {title}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Chip
            label={verified ? "تایید شده" : "تایید نشده"}
            size='small'
            color={verified ? "primary" : "secondary"}
          />
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Chip
            label={traslated ? "ترجمه شده" : "ترجمه نشده"}
            size='small'
            color={traslated ? "primary" : "secondary"}
          />
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Box display="flex" alignItems="center">
          <Typography className={classes.titleRoot} component="div" variant="h4">
            {toPersianDate(newsDate)}
          </Typography>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Tooltip title="ویرایش">
          <IconButton size="small" target="_blank" href={`/news-management/?news=${id}`}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
      <TableCell className={classes.tableCellRoot}>
        <Tooltip title="حذف">
          <IconButton size="small" color='secondary' target="_blank" onClick={handleDelete}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default NewsItemCell;

NewsItemCell.prototype = {
  contact: PropTypes.object.isRequired,
  onShowContactDetail: PropTypes.func,
};
